// Ask the authorized same-origin API for a fresh short-lived link, then let
// hls.js download bytes directly from S3, without redirect or auth headers.
export async function setupMediaRequest(
  xhr: XMLHttpRequest, requestUrl: string, headers: Record<string, string> = {},
) {
  const target = new URL(requestUrl, window.location.origin)
  xhr.withCredentials = false
  if (target.origin !== window.location.origin) return
  if (/\/api\/v1\/videos\/(lesson|assignment)\/\d+\/video\/\d+\/hls\/(?!.*\.m3u8$)[^/]+$/.test(target.pathname)) {
    target.searchParams.set('delivery', 'direct')
    const response = await fetch(target.href, { headers, credentials: 'same-origin' })
    if (!response.ok) throw new Error(`MEDIA_ACCESS_${response.status}`)
    if (response.headers.get('Content-Type')?.includes('application/json')) {
      const data = await response.json()
      const signed = new URL(data.url)
      if (signed.protocol !== 'https:') throw new Error('INVALID_MEDIA_LINK')
      xhr.open('GET', signed.href, true)
      return
    }
    // Legacy local media endpoint: no signed JSON response.
  }
  xhr.open('GET', requestUrl, true)
  Object.entries(headers).forEach(([key, value]) => xhr.setRequestHeader(key, value))
}
